(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bd-pdp-expert-drawer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bd-pdp-expert')) {
  customElements.define('bd-pdp-expert', class extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.openDrawer = (event) => {
        const trigger = event.target.closest('[data-bd-expert-open]');
        if (!trigger || trigger.dataset.bdExpertOpen !== this.dialog.id) return;
        if (typeof this.dialog.showModal !== 'function') return;
        event.preventDefault();
        if (this.dialog.open) return;
        this.trigger = trigger;
        this.overflow = document.documentElement.style.overflow;
        this.dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
      };
      document.addEventListener('click', this.openDrawer, options);
      this.querySelector('[data-expert-close]').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('click', (event) => {
        if (event.target !== this.dialog) return;
        const bounds = this.dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => {
        document.documentElement.style.overflow = this.overflow || '';
        this.trigger?.focus({ preventScroll: true });
      }, options);
      document.addEventListener('on:variant:change', (event) => {
        const variant = event.detail?.variant;
        if (!variant || !this.closest('.shopify-section')?.contains(event.target)) return;
        const finish = variant.title === 'Default Title' ? '' : variant.title;
        this.querySelector('[data-expert-variant]').textContent = [finish, variant.sku].filter(Boolean).join(' · ');
        const context = this.dataset.productTitle + (variant.sku ? ` (SKU ${variant.sku})` : '');
        this.querySelectorAll('a[href^="sms:"]').forEach((link) => {
          const number = link.getAttribute('href').split('?')[0];
          link.setAttribute('href', `${number}?&body=${encodeURIComponent(`${this.dataset.smsPrefill || ''} Re: ${context}`.trim())}`);
        });
      }, options);
    }
    disconnectedCallback() {
      this.abort?.abort();
      if (this.dialog?.open) {
        this.dialog.close();
        document.documentElement.style.overflow = this.overflow || '';
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
